import Button from "@material-ui/core/Button"
import {withStyles} from "@material-ui/styles"

/**
 * The PageNumberButton and StyledButtonGroup with material-ui customized using styled components
 */
export default withStyles({
  root: {
    height: "var(--action-item-height)",
    minWidth: 42,
    color: "var(--modes-on-primary-container)",
    fontWeight: "var(--font-weight-semibold)",
    fontSize: "var(--font-size-paragraph-large)",
    paddingLeft: 8,
    paddingRigt: 8,
    backgroundColor: "var(--modes-background)",
    border: "1px solid var(--modes-primary)",
    borderRadius: 4,

    "&:hover": {
      color: "var(--color-primitives-evergreen-evergreen30)",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  containedSecondary: {
    border: "2px solid var(--modes-primary)",
    boxShadow: "none",
    color: "var(--modes-on-primary-container)",
    fontFamily: "var(--secondary-font-family)",
    lineHeight: "var(--line-height)",
    fontSize: "var(--font-size-paragraph-large)",
    fontWeight: "var(--font-weight-semibold)",
    backgroundColor: "var(--modes-primary-container)",
    "&:hover": {
      color: "var(--color-primitives-evergreen-evergreen30)",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  contained: {
    border: "2px solid var(--modes-primary)",
    paddingLeft: 8,
    paddingRight: 8,
    boxShadow: "none",
    color: "var(--modes-on-primary-container)",
    fontFamily: "var(--secondary-font-family)",
    lineHeight: "var(--line-height)",
    fontSize: "var(--font-size-paragraph-large)",
    fontWeight: "var(--font-weight-semibold)",
    backgroundColor: "var(--modes-primary-container)",
    "&:hover": {
      backgroundColor: "var(--color-primitives-evergreen-evergreen50)",
      boxShadow: "none",
    },
  },
  disabled: {
    opacity: 0.5,
  },
})(Button)
